import { Servidor } from './servidor';
import { Localidade } from './localidade';
import { Sistema } from './sistema';
export class SistemaInfo {
  id: number = null; //Chave primária de identificacao
  //sistema: Sistema = null; //Chave estrangeira para indicar o sistema
  dsCaminhoApp: string = null; //
  dsCaminhoGit: string = null; //
  bbIcone: string = null; //
  flNacional: string = null; //
  flArea: string = null; //
  localidadeGestor: Localidade = null; //
  servidorGestor: Servidor = null; //
  dsTecnologias: string = null; //
  dsObservacoes: string = null; //
  dsEmailLista: string = null; //
  snAtivo: string = null; //
  flFase: string = null; //

  constructor(d?) {
    this.id = d.id ? d.id : null;
    //this.sistema = d.sistema ? new Sistema(d.sistema) : null;
    this.dsCaminhoApp = d.dsCaminhoApp ? d.dsCaminhoApp : null;
    this.dsCaminhoGit = d.dsCaminhoGit ? d.dsCaminhoGit : null;
    this.bbIcone = d.bbIcone ? d.bbIcone : null;
    this.flNacional = d.flNacional ? d.flNacional : null;
    this.flArea = d.flArea ? d.flArea : null;
    this.localidadeGestor = d.localidadeGestor
      ? new Localidade(d.localidadeGestor)
      : null;
    this.servidorGestor = d.servidorGestor
      ? new Servidor(d.servidorGestor)
      : null;
    this.dsTecnologias = d.dsTecnologias ? d.dsTecnologias : null;
    this.dsObservacoes = d.dsObservacoes ? d.dsObservacoes : null;
    this.dsEmailLista = d.dsEmailLista ? d.dsEmailLista : null;
    this.snAtivo = d.snAtivo ? d.snAtivo : null;
    this.flFase = d.flFase ? d.flFase : null;
  }
}
